import AUStates from './th-TH/AU-states.json.js';
import CAStates from './th-TH/CA-states.json.js';
import CNStates from './th-TH/CN-states.json.js';
import CompanySize from './th-TH/company-size.json.js';
import CompanyType from './th-TH/company-type.json.js';
import countries from './th-TH/countries.json.js';
import DEStates from './th-TH/DE-states.json.js';
import HKStates from './th-TH/HK-states.json.js';
import INStates from './th-TH/IN-states.json.js';
import industry from './th-TH/industry.json.js';
import interests from './th-TH/interests.json.js';
import jobRole from './th-TH/job-role.json.js';
import levelOfAWSUsage from './th-TH/level-of-aws-usage.json.js';
import projectTimeline from './th-TH/project-timeline.json.js';
import PTStates from './th-TH/PT-states.json.js';
import USStates from './th-TH/US-states.json.js';
import useCase from './th-TH/use-case.json.js';
import languagePreference from './th-TH/language-preference.json.js';
import Navatar from '../th-TH/translation.json.js';

const dropdownsData = {
    ...AUStates,
    ...CAStates,
    ...CNStates,
    ...CompanySize,
    ...CompanyType,
    ...countries,
    ...DEStates,
    ...HKStates,
    ...INStates,
    ...industry,
    ...interests,
    ...jobRole,
    ...levelOfAWSUsage,
    ...projectTimeline,
    ...PTStates,
    ...USStates,
    ...useCase,
    ...Navatar.translation,
    ...languagePreference,
};

export { dropdownsData as default };
